<div
  class="modal-backdrop"
  [class.show]="isOpen()"
  (click)="onBackdropClick($event)"
  (keydown)="onEscapeKey($event)"
  tabindex="-1"
  role="dialog"
  [attr.aria-labelledby]="title() ? 'modal-title' : null"
  aria-modal="true"
>
  <div class="modal-container" [class]="size()">
    <div class="modal-header">
      <h2 class="modal-title" id="modal-title">{{ title() }}</h2>
      <button type="button" class="modal-close" (click)="close()" aria-label="Cerrar modal">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="modal-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
